/** 3-letter country code → flag emoji (via regional-indicator codepoints). */
const ISO3_TO_2: Record<string, string> = {
  BRA: 'BR', JPN: 'JP', COD: 'CD', CRC: 'CR', GER: 'DE', AUS: 'AU', FRA: 'FR',
  GRE: 'GR', SWE: 'SE', IND: 'IN', ITA: 'IT', MAD: 'MG', USA: 'US', GBR: 'GB',
  ARG: 'AR', MAR: 'MA', KEN: 'KE',
};

export function countryFlag(code3: string | undefined): string {
  const c2 = ISO3_TO_2[code3 ?? ''];
  if (!c2) return '🏳️';
  return String.fromCodePoint(...[...c2].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}
